import { ClassProvider, InjectionToken, Type } from '@angular/core';
import { GenericStorageApiService } from '@portal/storage-api/data-access';

export const UPLOAD_FILE_API = new InjectionToken<GenericStorageApiService>('UPLOAD_FILE_API');

export const getUploadFileApiProvider = (value: Type<GenericStorageApiService>): ClassProvider => ({
  provide: UPLOAD_FILE_API,
  useClass: value,
});
